import { api } from "../api";

/**
 * updateGeofenceStatusById - Function that updates on database an existing geofence status by id   
 * /geofences/{customerId}/{departmentId}/{id}/{status}  
 * method PUT 
 * @async-function
 */
const updateGeofenceStatusById = async (token: string, id: number, customerId: number, status: string) => {
    const response = await api.put(
        `/geofences/${customerId}/${id}/${status}`, { status }, {
             headers: { 'Authorization': `Bearer ${token}` }
        });
    return response;
};
export default updateGeofenceStatusById;
